import { InjectionToken } from '@angular/core';

/**
 * The URL prefix under which the forms feature is mounted.
 * - Standalone app: '' (routes live at root, e.g. /forms, /incidents)
 * - Embedded in portal: '/incidents' (routes live at /incidents/forms, /incidents/incidents, …)
 */
export const FORMS_BASE_PATH = new InjectionToken<string>('FORMS_BASE_PATH', {
  providedIn: 'root',
  factory: () => '',
});
